module.exports = __webpack_public_path__ + "static/media/om_eyeshape_upturned_hazel.aa436bb3.png";